import {
  GET_RESTAURANT_INFO,
  GET_RESTAURANT_INFO_BY_ID,
  GET_RESTAURANT_ITEMS,
  RESET_INFO,
  RESET_ITEMS,
  SINGLE_ITEM,
  SEARCH_ITEM,
  CLEAR_SEARCH,
  SET_FAVORITE_REST,
  SET_MAPPED_REST,
  GET_RESTAURANT_INFO_FOR_LOGGED_IN_USER,
  GET_HOME_PRODUCTS,
  GET_PRICE_SORTED_PRODUCTS,
  GET_PRICE_SORTED_SHOW_MORE_PRODUCTS
} from "./actionTypes";

// RESET_BACKUP,

const initialState = {
  restaurant_info: [],
  restaurant_items: [],
  single_item_id: null,
  recommended_items: [],
  recommended_item_index: null,
  recommended_item_category: null,
  is_item_recommended: false,
  restaurant_backup_items: [],
  homeProducts: null,
  priceSortedProducts: null
};

/**
 * Merge partial responses for the same store without dropping derived fields.
 * Cart, favorite, and mapping endpoints do not always return the full store.
 */
function mergeRestaurantInfo(prev, next) {
  const hasPreviousStore =
    prev &&
    typeof prev === "object" &&
    !Array.isArray(prev) &&
    prev.id != null;
  const hasNextObject =
    next && typeof next === "object" && !Array.isArray(next);

  // An incomplete response must never erase a valid store object.
  if (!hasNextObject) {
    return hasPreviousStore ? prev : next;
  }
  if (hasPreviousStore && next.id == null) {
    return { ...prev, ...next };
  }

  if (
    !hasPreviousStore ||
    next.id == null ||
    String(prev.id) !== String(next.id)
  ) {
    return next;
  }
  const merged = { ...next };
  const prevSlabs = prev.delivery_slabs || prev.deliverySlabs;
  const nextSlabs = next.delivery_slabs || next.deliverySlabs;
  if (
    Array.isArray(prevSlabs) &&
    prevSlabs.length > 0 &&
    (!Array.isArray(nextSlabs) || nextSlabs.length === 0)
  ) {
    merged.delivery_slabs = prevSlabs;
    merged.delivery_charge_type =
      next.delivery_charge_type || prev.delivery_charge_type;
  }
  // Keep store-page road km / ETA when a later fetch (e.g. by id) omits them.
  if (
    (merged.distance == null || merged.distance === "") &&
    prev.distance != null &&
    prev.distance !== ""
  ) {
    merged.distance = prev.distance;
  }
  if (!merged.eta_label && prev.eta_label) {
    merged.eta_label = prev.eta_label;
  }
  if (merged.eta_minutes == null && prev.eta_minutes != null) {
    merged.eta_minutes = prev.eta_minutes;
  }
  return merged;
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_RESTAURANT_INFO:
      return { ...state, restaurant_info: mergeRestaurantInfo(state.restaurant_info, action.payload) };
    case GET_RESTAURANT_INFO_BY_ID:
      return { ...state, restaurant_info: mergeRestaurantInfo(state.restaurant_info, action.payload) };
    case GET_RESTAURANT_ITEMS:
      return {
        ...state,
        restaurant_items: action.payload,
        restaurant_backup_items: action.payload,
      };
    //restaurant_backup_items: action.payload,
    case RESET_ITEMS:
      return { ...state, restaurant_items: action.payload };
    // case RESET_BACKUP:
    //   return { ...state, restaurant_backup_items: action.payload };
    case RESET_INFO:
      return { ...state, restaurant_info: action.payload };
    case SINGLE_ITEM:
      return { ...state, single_item_id: action.payload };
    case SEARCH_ITEM:
      return { ...state, restaurant_items: action.payload };
    case CLEAR_SEARCH:
      return { ...state, restaurant_items: state.restaurant_backup_items };
    case SET_FAVORITE_REST: {
      // Toggle-favorite returns a bare restaurant (no eta_label / dynamic distance).
      // Merge only is_favorited so Delivery ETA stays consistent on the store page.
      const prev = state.restaurant_info;
      const next = action.payload;
      if (
        prev &&
        next &&
        typeof prev === "object" &&
        !Array.isArray(prev) &&
        prev.id != null &&
        next.id != null &&
        String(prev.id) === String(next.id)
      ) {
        return {
          ...state,
          restaurant_info: {
            ...prev,
            is_favorited: next.is_favorited,
          },
        };
      }
      return {
        ...state,
        restaurant_info: mergeRestaurantInfo(prev, next),
      };
    }
    case SET_MAPPED_REST:
      return {
        ...state,
        restaurant_info: mergeRestaurantInfo(
          state.restaurant_info,
          action.payload
        ),
      };
    case GET_RESTAURANT_INFO_FOR_LOGGED_IN_USER:
      return { ...state, restaurant_info: mergeRestaurantInfo(state.restaurant_info, action.payload) };
    case 'CHECK_RECOMMENDED':
      return {
        ...state,
        recommended_items: action.payload.recommendedItems || [],
        recommended_item_index: action.payload.index,
        recommended_item_category: action.payload.category,
        is_item_recommended: true
      };
    case GET_HOME_PRODUCTS:
      return { ...state, homeProducts: action.payload };
    case GET_PRICE_SORTED_PRODUCTS:
      return { ...state, priceSortedProducts: action.payload };
    default:
      return state;
  }
}
